export const ClientConstants = {
  clientData: "client_data"
}